<template>
    <div class="modal-container-cont">
        <div class="modal-container">
            <div class="modal-form-container">
                <div class="title-box">
                    <h2>{{ getString('recarga_de_saldo') }}</h2>
                </div>
            </div>

            <div class="form">
                <div class="config-item distance-bottom">
                    <div class="label-container" :class="{'disabled-label': paymentMode}">
                        <label for="value" v-text="getString('valor_da_recarga')"></label>
                    </div>
                    <div id="value" ref="valueDiv" class="div-input-android" :class="{'disabled-input': paymentMode}"></div>
                </div>
                <div class="config-item">
                    <div class="label-container" :class="{'disabled-label': paymentMode}">
                        <label for="familyPicker" v-text="getString('familia_de_produtos')"></label>
                    </div>
                    <select class="modelosPreDefinidos" :class="{'disabled-input': paymentMode, 'white-background': !paymentMode}" name="familyPicker" id="familyPicker" v-model="currentFamily">
                        <option value="null" selected></option>
                        <option :value="family" v-for="(family, key) in productFamilies" :key="key" v-text="family.familyName"></option>
                    </select>
                </div>
            </div>

            <div v-if="paymentMode" class="payment-options">
                <h2 v-text="getString('selecione_forma_pagamento')"></h2>
                <div class="methods-container">
                    <DefaultButton v-for="(method, key) in paymentMethods" :key="key"
                        :text="method.DSBUTTON" class="buttons"
                        @defaultBtnClick="doRechargePayment(method)">
                    </DefaultButton>
                </div>
            </div>

            <AndroidKeyboard id="android-keyboard" v-if="!paymentMode"
                :inputElement="inputElement"
                :layout="layout"
                :bigNumeric="true"
                :onInput="applyMoneyRules">
            </AndroidKeyboard>

            <div class="prod-item-footer">
                <DefaultButton :text="getString('cancelar')" outlined="true" @defaultBtnClick="closeModal()"></DefaultButton>
                <DefaultButton v-if="!paymentMode" :text="getString('confirmar')" @defaultBtnClick="modalConfirm()"></DefaultButton>
            </div>

            <!-- <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :data-layout="layout" :cancel="hide" :accept="accept" :input="input"/> -->
        </div>
        <div class="loading-img-overlay" v-if="loading"></div>
        <div class="info-model" v-if="loading">
            <img :src="getImage('maquininha') || realize_pagamento">
            <div class="message" >
                <span> {{ this.tefMessage }} </span>
            </div>
        </div>

        <WalletModal v-if="chooseWallet" :qrCodeEventData="qrCodeEventData" @closeWalletModal="closeWalletModal"></WalletModal>
    </div>
</template>

<script>
// import Vue from 'vue'
// import VueTouchKeyboard from 'vue-touch-keyboard'
// import style from 'vue-touch-keyboard/dist/vue-touch-keyboard.css'
import LocaleController from '@/assets/controllers/LocaleController'
import DefaultButton from '@/components/DefaultButton'
import PaymentController from '@/assets/controllers/PaymentController'
import PaymentTimeoutController from '@/assets/controllers/PaymentTimeoutController'
import Util from '@/assets/libs/util'
import eventModule from '@/assets/libs/eventModule'
import WalletModal from '@/components/WalletModal'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'

// Vue.use(VueTouchKeyboard)
// Vue.use(style)

export default {
    name: 'RechargeModal',
    components: {
        DefaultButton,
        WalletModal,
        AndroidKeyboard
        // 'vue-touch-keyboard': VueTouchKeyboard.component
    },
    props: ['productFamilies'],
    data () {
        return {
            inputElement: null,
            // visible: false,
            // options: {
            //     useKbEvents: false,
            //     preventClickEvent: false
            // },
            layout: keyboardLayout.MONEY_NUMERIC_NO_CONFIRM,
            input: null,
            loading: false,
            rawValue: null,
            cpf: null,
            value: null,
            controlsEnabled: true,
            paymentMode: false,
            paymentMethods: [],
            chooseWallet: false,
            qrCodeEventData: null,
            currentFamily: null,
            cpfMask: '###.###.###-##',
            realize_pagamento: require('../../static/icons/realize_pagamento.jpg'),
            tefMessage: ''
        }
    },
    created () {
        eventModule.$on('showWalletOptions', this.showWalletOptions)
        eventModule.$on('qrCodeReceived', this.qrCodeReceived)
        eventModule.$on('setTefMessage', this.setTefMessage)
    },
    beforeDestroy () {
        eventModule.$off('showWalletOptions', this.showWalletOptions)
        eventModule.$off('qrCodeReceived', this.qrCodeReceived)
        eventModule.$off('setTefMessage', this.setTefMessage)
    },
    mounted () {
        this.tefMessage = ''
        this.inputElement = this.$refs.valueDiv
        this.paymentMethods = this.getFilteredPaymentMethods()
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getFilteredPaymentMethods: function () {
            let paymentMethods = PaymentController.getPaymentMethods()
            paymentMethods = paymentMethods.filter(
                method => method.IDTIPORECE !== 'A' && method.IDTIPORECE !== '9' && method.IDTIPORECE !== '4'
            )
            return paymentMethods
        },
        getImage: function (value) {
            return Util.getConfigImage(value)
        },
        sanitizeValue: function () {
            this.rawValue = this.rawValue.replace(/[^0-9,.]+/g, '')
        },
        sanitizeCpf: function () {
            this.cpf = this.cpf.replace(/[^0-9.-]+/g, '')
        },
        showWalletOptions: function () {
            if (!this.chooseWallet) this.chooseWallet = true
        },
        qrCodeReceived: function (eventData) {
            if (!this.chooseWallet) {
                this.qrCodeEventData = eventData
                this.chooseWallet = true
            } else {
                eventModule.$emit('qrCodeForwarded', eventData)
            }
        },
        closeWalletModal: function () {
            this.chooseWallet = false
        },
        closeModal: function () {
            if (this.controlsEnabled) {
                this.$emit('closeRechargeModal')
            }
        },
        modalConfirm: function () {
            this.rawValue = this.$refs.valueDiv.innerText

            let result = this.validateInputs()
            if (result.isValid) {
                this.changeToPaymentMode()
            } else {
                Util.showInfoModal(result.message)
            }
        },
        changeToPaymentMode: function () {
            this.paymentMode = true
            this.visible = false
        },
        disableControls: function () {
            this.controlsEnabled = false
            this.$emit('disableOverlayClick')
        },
        enableControls: function () {
            this.controlsEnabled = true
            this.$emit('enableOverlayClick')
        },
        validateInputs: function () {
            let result = {
                isValid: true,
                message: ''
            }

            if (this.rawValue == null || this.rawValue === '' /* || this.cpf == null || this.cpf === '' */) {
                result.isValid = false
                result.message = this.getString('todos_campos_obrigatorios')
                return result
            }

            this.rawValue = this.rawValue.replace(',', '.')
            this.value = parseFloat(this.rawValue).toFixed(2)
            this.value = this.value.replace('.', ',')

            let valueIsEmpty = this.value.length === 0

            if (valueIsEmpty) {
                result.isValid = false
                result.message = this.getString('todos_campos_obrigatorios')
                return result
            }

            if (parseFloat(this.rawValue) <= 0) {
                result.isValid = false
                result.message = this.getString('valor_informado_deve_ser_maior_que_zero')
                return result
            }

            let typedValue = this.rawValue.replace('.', ',')
            let parts = typedValue.split(',')
            let decimalPart = parts[1]
            if (decimalPart && decimalPart.length > 2) {
                result.isValid = false
                result.message = this.getString('valor_informado_casas_decimais')
                return result
            }

            let hasSelectedFamily = this.currentFamily && this.currentFamily.familyCode && this.currentFamily.familyCode.length > 0
            if (!hasSelectedFamily) {
                result.isValid = false
                result.message = this.getString('selecione_familia_produtos')
                return result
            }

            this.rawValue = this.value
            return result
        },
        doRechargePayment: async function (paymentMethod) {
            this.disableControls()
            this.showLoadingImage()

            if (paymentMethod.IDTIPORECE !== '9' && paymentMethod.IDTIPORECE !== 'A' && paymentMethod.IDTIPORECE !== '4') {
                PaymentTimeoutController.start()
            }

            let orderCPF = this.cpf || ''
            let rechargeValue = this.value
            let rechargeFamily = this.currentFamily.familyCode
            let paymentResponse = await PaymentController.doPayment(paymentMethod, orderCPF, this.$router, rechargeValue, rechargeFamily)

            if (paymentResponse.error) {
                this.handleTefError(paymentResponse)
            } else if (this.successResponse(paymentResponse)) {
                this.hideLoadingImage()
                this.enableControls()
                this.$emit('newBalanceReceived', paymentResponse.data)
                this.$emit('closeRechargeModal')
                let infoMessage = this.getString('recarga_realizada_com_sucesso')
                Util.showInfoModal(infoMessage)
            } else {
                this.handleGenericError()
            }

            this.enableControls()
        },
        concomitantTefTransactionError: function (paymentResponse) {
            return paymentResponse && paymentResponse.error === true && paymentResponse.errorType === 'concomitant tef transaction'
        },
        handleConcomitantTefTransactionError: function () {
            // Não exibir nada na tela, a rotina TEF iniciada primeiro deve seguir normalmente e o usuário não deve ser
            // alertado da tentativa de iniciar a segunda
        },
        handleTefError: function (paymentResponse) {
            this.hideLoadingImage()
            // this.forceModalCloseOnAndroid()
            Util.showInfoModal(paymentResponse.errorType || this.getString('problema_nao_identificado_TEF_tente_novamente'))
        },
        handleGenericError: function () {
            this.hideLoadingImage()
            let infoMessage = this.getString('nao_possivel_realizar_recarga_valor_estornado')
            Util.showInfoModal(infoMessage)
        },
        successResponse: function (paymentResponse) {
            return paymentResponse && paymentResponse.success && paymentResponse.data && paymentResponse.data !== []
        },
        showLoadingImage: function () {
            this.loading = true
        },
        hideLoadingImage: function () {
            this.loading = false
        },
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        hide: function () {
            this.visible = false
        },
        applyMoneyRules: function (input) {
            if (!input) return ''

            input = this.notAllowDuplicatedComma(input)
            input = this.notAllowExcedentDecimalCases(input)

            return input
        },
        notAllowDuplicatedComma: function (input) {
            let firstComma = input.indexOf(',')
            let lastComma = input.lastIndexOf(',')
            if (firstComma !== -1 && firstComma !== lastComma) {
                input = input.slice(0, -1)
            }
            return input
        },
        notAllowExcedentDecimalCases: function (input) {
            let array = input.split(',')
            if (array.length > 1 && array[1].length > 2) {
                input = input.slice(0, -1)
            }
            return input
        },
        setTefMessage: function (text) {
            this.tefMessage = text
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .modal-container-cont{
        .full;
        pointer-events: none;
        display: block;
        bottom: 0;
        z-index: 5;
    }

    .modal-container {
        position: absolute;
        pointer-events: auto;
        left: 0;
        right: 0;
        top: 50%;
        margin: auto 75px;
        background: @white;
        border-radius: 25px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        transform: translate(0%, -50%);

        .modal-form-container {
            position: relative;
            overflow: hidden auto;

            .title-box {
                background-color: @primary-color;
                height: 120px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 25px 25px 0px 0px;

                h2 {
                    color: @white;
                    margin: auto;
                    font-size: 40px;
                }
            }
        }

        .form {
            margin: 0px 60px 0px 60px;
            height: 350px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .config-item {
                display: grid;
                grid-template-columns: 40% 60%;
                position: relative;

                label {
                    font-size: 30px;
                    position: relative;
                    display: inline-block;
                    top: 50%;
                    transform: translate(0, -50%);
                    margin: 0;
                }
                .white-background {
                    background-color: white;
                }
                .disabled-input {
                    pointer-events: none;
                    background: rgba(0, 0, 0, 0.1);
                    border: 2px solid lightgray;
                    color: gray !important;
                }
                .disabled-label {
                    pointer-events: none;
                }
                select {
                    height: 60px;
                    border: 2px solid @primary-color;
                    font-size: 2rem;
                    padding: 5px 15px;
                    outline: none;
                }
            }

            .distance-bottom {
                margin-bottom: 45px;
            }

            .div-input-android {
                position: relative;
                display: flex;
                align-items: center;
                font-size: 2rem;
                height: 55px;
                background-color: white;
                color: black;
                border: 2px solid @primary-color;
                padding: 0 20px;
            }
        }

        .payment-options {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 60px;
            h2 {
                font-size: 40px;
                color: @primary-color;
                margin-bottom: 60px;
            }
            .methods-container {
                max-height: 600px;
                width: 100%;
                overflow: hidden auto;
            }
            .buttons {
                margin: 0px auto 30px auto;
            }
        }

        .balance-information {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 60px;
            max-height: 750px;
            overflow: hidden auto;

            .balance-inner-information {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 60px;
            }

            .total-div {
               margin-bottom: 60px;
            }

            .upper-div {
                margin-bottom: 15px;
            }

            .margin-top {
                margin-top: 15px;
            }

            h2 {
                font-size: 40px;
                color: @primary-color;
                margin-bottom: 60px;
            }

            .balance-text {
                font-size: 30px;
            }

            .balance-value {
                font-size: 40px;
                color: @primary-color;
            }
        }

        .prod-item-footer {
            position: relative;
            display: flex;
            background: rgba(0, 0, 0, 0.1);
            height: 180px;
            border-radius: 0px 0px 25px 25px;

            button {
                position: relative;
                display: block;
                margin: auto;
            }
        }

        #android-keyboard {
            margin: 0 70px 30px 70px;
        }
    }

    #keyboard {
        .keyboard;
        width: inherit;
        max-width: 930px;
        top: inherit;
        bottom: 0;
        position: unset;
    }

    .info-model {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 6;
        max-height: 1500px;
        height: fit-content;
        margin: auto 75px;
        background-color: white;
        color: black;
        border-radius: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        img {
            margin: 30px;
            max-height: 1000px;
            max-width: 800px;
            // margin: auto;
        }
        .message {
            padding: 20px;
            text-align: center;
            span {
                font-size: 2rem;
                text-align: center;
                white-space: pre-line;
            }
        }
    }
    .loading-img-overlay {
        z-index: 5;
        pointer-events: auto;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
    }

    @media (max-width: 698px) { // Gertec SK210
        .modal-container {
            margin: auto 30px;
            .modal-form-container {
                .title-box {
                    height: 50px;
                    h2 {
                        font-size: 30px;
                    }
                }
            }
            .form {
                margin: 0px 30px 0px 30px;
                height: 160px;
                .config-item {
                    grid-template-columns: 30% 70%;
                    label {
                        font-size: 20px;
                    }
                    .div-input-android {
                        font-size: 25px;
                        height: 35px;
                        padding: 0 10px;
                    }
                    select {
                        height: 40px;
                        font-size: 25px;
                        padding: 0 10px;
                    }
                }
                .distance-bottom {
                    margin-bottom: 15px;
                }
            }
            #android-keyboard {
                margin: 0;
                .small-screen-keyboard;
                bottom: 30px;
            }
            .payment-options {
                margin-bottom: 0;
                h2 {
                    font-size: 25px;
                    margin: 0 auto 20px auto;
                }
                .methods-container {
                    max-height: 250px;
                }
                .buttons {
                    margin: 0px auto 10px auto;
                    width: 230px;
                }
            }
            .prod-item-footer {
                height: 60px;
            }
        }
        .info-model {
            img {
                max-height: 350px;
                max-width: 300px;
                // margin: auto;
            }
            .message {
                padding: 20px;
                text-align: center;
                span {
                    font-size: 1.1rem;
                }
            }
        }
        .loading-img-overlay {
            z-index: 6;
            pointer-events: auto;
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.8);
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        .modal-container {
            margin: auto 50px;

            .modal-form-container {
                .title-box {
                    height: 100px;
                    h2 {
                        font-size: 35px;
                    }
                }
            }

            .form {
                margin: 0px 30px 0px 30px;
                height: 250px;
                .config-item {
                    grid-template-columns: 30% 70%;
                }
            }

            .balance-information {
                margin-bottom: 30px;
                max-height: 500px;
                .balance-inner-information {
                    margin-bottom: 50px;
                }
                .total-div {
                    margin-bottom: 40px;
                }
                .upper-div {
                    margin-bottom: 10px;
                }
                h2 {
                    font-size: 35px;
                    margin-bottom: 40px;
                }
                .balance-text {
                    font-size: 25px;
                }
                .balance-value {
                    font-size: 30px;
                }
            }
            .payment-options {
                margin-bottom: 0;
                h2 {
                    font-size: 30px;
                    margin: 0 auto 20px auto;
                }
                .methods-container {
                    max-height: 450px;
                }
                .buttons {
                    margin: 0px auto 10px auto;
                    width: 230px;
                }
            }
            .prod-item-footer {
                height: 130px;
            }
        }

        .info-model {
            img {
                max-height: 1000px;
                max-width: 550px;
                // margin: auto;
            }
            .message {
                padding: 20px;
                text-align: center;
                span {
                    font-size: 1.5rem;
                }
            }
        }
        .loading-img-overlay {
            z-index: 6;
            pointer-events: auto;
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.8);
        }

        #keyboard {
            .keyboard;
            width: inherit;
            position: unset;
            max-width: 760px;
            font-size: 20px;
        }
    }

    @media (orientation: landscape) {
        .modal-container {
            margin: auto 160px;
            .modal-form-container {
                .title-box {
                    height: 50px;
                    h2 {
                        font-size: 30px;
                    }
                }
            }
            .form {
                margin: 0px 30px 0px 30px;
                height: 160px;
                .config-item {
                    grid-template-columns: 30% 70%;
                    label {
                        font-size: 20px;
                    }
                    .div-input-android {
                        font-size: 25px;
                        height: 35px;
                        padding: 0 10px;
                    }
                    select {
                        height: 40px;
                        font-size: 25px;
                        padding: 0 10px;
                    }
                }
                .distance-bottom {
                    margin-bottom: 15px;
                }
            }
            #android-keyboard {
                margin: 0;
                .small-screen-keyboard;
                bottom: 30px;
            }
            .payment-options {
                margin-bottom: 0;
                h2 {
                    font-size: 25px;
                    margin: 0 auto 20px auto;
                }
                .methods-container {
                    max-height: 250px;
                }
                .buttons {
                    margin: 0px auto 10px auto;
                    width: 230px;
                }
            }
            .prod-item-footer {
                height: 100px;
            }
        }
        .info-model {
            img {
                max-height: 350px;
                max-width: 300px;
                // margin: auto;
            }
            .message {
                padding: 20px;
                text-align: center;
                span {
                    font-size: 1.1rem;
                }
            }
        }
        .loading-img-overlay {
            z-index: 6;
            pointer-events: auto;
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.8);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/RechargeModal.vue